<template>
  <div class="artworks-box">
    <router-link
      v-for="(artwork, key) in artworks"
      :key="`${key}-artwork`"
      :to="{ path: `/artworks/${artwork.slug}` }"
      v-slot="{ navigate }"
      custom
    >
      <div class="artworks-box_card" @click="navigate">
        <div class="image-box">
          <img class="image" :src="artwork.search_image" />
          <div class="hover-container">Click to View</div>
        </div>
        <h3 class="title">{{ artwork.title }}</h3>
        <span class="author">{{ artwork.artist }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    artworks: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.artworks-box {
  @include gridLayoutResponsive;

  &_card {
    @include flexColumnClickable;

    &:hover {
      .image-box {
        .hover-container {
          opacity: 1;
        }
      }
    }

    .image-box {
      position: relative;

      .image {
        @include imageContainer();
        @media screen and (max-width: $xs) {
          height: 90vw;
        }
      }

      .hover-container {
        @include imagePreviewHover;
      }
    }

    .title {
      font-size: 2.4rem;
      line-height: 3.1rem;
      margin-top: 1rem;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-clamp: 2;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .author {
      margin-top: 0.5rem;
      font-size: 1.4rem;
      line-height: 2.5rem;
      text-transform: uppercase;
      word-spacing: 3px;
      @media screen and (max-width: $xs) {
        margin-top: 1rem;
        font-size: 1.6rem;
        line-height: 2.8rem;
      }
    }
  }
}
</style>

